import request from "../request"
import qs from "qs";


export function getFlightPlanDataById(params) {
  return request.get({
    url: "/fly_plan/details",
    params: params
  })
}
export function getFlightPlanTableData(params) {
  return request.get({
    url: "/fly_plan/page",
    params: params
  })
}
export function getFlightPlanOptions() {
  return request.get({
    url: "/security/api/role/opt"
  })
}


export function addFlightPlanData(data) {
  return request.post({
    url: "/fly_plan/saveorupdate",
    data: qs.stringify(data),
    headers: {
      "Content-Type": "application/x-www-form-urlencoded"
    }
  })
}
export function auditFlightPlan(params) {
    return request.put({
        url: '/fly_plan/audit', 
        params: params
    })
}


